export default {"src":"/_next/static/media/CH.e34b73ef.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};